module.exports = __webpack_public_path__ + "static/media/Step 1-Location_Book.a1f06e7a.png";